<sui-dialog-simple [(error)]="apiError">
  <ng-template suiDialogHeader>
    <fa-icon [icon]="actionIcon"></fa-icon>
    <h2 ngpDialogTitle>{{ dialogTitle }}</h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>
  <ng-template suiDialogContent>
    <div class="related-wrapper">
      <div class="related-settings">
        <form [formGroup]="formGroup">
          <!-- Search Related Articles Textarea -->
          <div class="related-query">
            <label for="searchRelatedArticles" sui-label>
              {{ "post-related.label.search-related-articles" | translate }}
            </label>
            <app-query-editor formControlName="filterQuery"></app-query-editor>
          </div>

          <!-- Dropdown for Search for Related Articles -->
          <div class="related-fields">
            <div class="related-feed">
              <label for="relatedArticlesDropdown" sui-label>
                {{ "post-related.label.select-base-search-feed" | translate }}
              </label>
              <!-- TODO: Check dropdown close for component below (app-data-object-select)  -->
              <app-data-object-select
                [objectClassIds]="[NomObjectClass.FEED]"
                [objectTypeIds]="[
                  NomObjectTypes.ONLINE_FEED,
                  NomObjectTypes.STORY_FEED,
                  NomObjectTypes.SOCIAL_FEED,
                  NomObjectTypes.BROADCAST_FEED,
                  NomObjectTypes.COMBINED_FEED,
                  NomObjectTypes.CLIPPING_FEED,
                ]"
                formControlName="searchFeedId"
              >
              </app-data-object-select>
            </div>
          </div>

          <!-- Period Toggle Buttons -->
          <div class="period-row">
            <div class="period-select" #periodSelect>
              <sui-button-group
                class="period-select__group"
                [options]="periods"
                size="sm"
                formControlName="period"
                aria-label="Period toggle"
                (click)="onPeriodClick()"
              ></sui-button-group>
              <!-- An unclickable trigger: the calendar opens from code, anchored to the period group -->
              <span
                [suiPopoverTrigger]="customRangePopover"
                [suiPopoverAnchor]="periodSelect"
                #customRangeTrigger="suiPopoverTrigger"
              ></span>

              <!-- The custom range calendar: a popover under the period group, opened when "custom" is picked -->
              <ng-template #customRangePopover>
                <div suiPopover class="custom-range-popover">
                  <div class="custom-range-popover__close">
                    <sui-button
                      size="sm"
                      variant="danger"
                      [leadingIcon]="['fas', 'times']"
                      [iconOnly]="true"
                      ariaLabel="Close"
                      (click)="customRangeTrigger.close()"
                    ></sui-button>
                  </div>
                  <!-- scanner-disable-next-line R10 -- legacy inline calendar, migrates to app-date-range-selection with its own ticket (WAP-1953 R10) -->
                  <sui-date-range-picker
                    [inline]="true"
                    [formControl]="customRangeControl"
                  ></sui-date-range-picker>
                  <div class="custom-range-popover__apply">
                    <sui-button
                      size="sm"
                      variant="primary"
                      (click)="applyCustomRange()"
                    >
                      {{ "post-related.button.apply-range" | translate }}
                    </sui-button>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="search">
              <sui-button
                variant="primary"
                [leadingIcon]="['fas', 'search']"
                (click)="search()"
              >
                {{ "btn.search" | translate }}
              </sui-button>
            </div>
          </div>

          <!-- Submit Button -->
        </form>
        <div class="posts-pane">
          <app-post-list
            [posts]="posts"
            [loading]="postsLoading"
            [viewConfig]="postViewConfig"
            [timeShown]="timeShown"
            [showAdvancedSearch]="false"
            [showPagination]="false"
            [disableTools]="true"
            [customTogglePostSelect]="togglePostSelect.bind(this)"
          >
            <!-- Custom sort toolbar projected into the post list. Stays visible
            with zero results while a relation filter is active, so the
            user can always change or remove the filter. -->
            @if (posts?.length > 0 || relationFilterActive) {
              <div postListToolbar class="tools">
                <!-- Select all results on the current page -->
                @if (posts?.length > 0) {
                  <div class="select-all">
                    <sui-checkbox
                      [checked]="allPageSelected"
                      [indeterminate]="somePageSelected"
                      (checkedChange)="toggleSelectAllOnPage()"
                      [suiTooltip]="
                        'post-related.tooltip.select-all-results-on-this-page'
                          | translate
                      "
                    >
                      {{ "post-related.label.select-all" | translate }}
                    </sui-checkbox>
                  </div>
                }
                <!-- View dropdown -->
                <div>
                  <sui-button
                    variant="ghost"
                    [leadingIcon]="['fas', 'eye']"
                    [trailingIcon]="['fas', 'caret-down']"
                    [expanded]="viewDropdown.isOpen()"
                    [suiPopoverTrigger]="viewPopover"
                    #viewDropdown="suiPopoverTrigger"
                  >
                    {{ "feed-actions.button.view" | translate }}
                  </sui-button>
                  <ng-template #viewPopover>
                    <div suiPopover class="view-dropdown-menu dropdown-menu">
                      @for (group of viewDropdownGroups; track group) {
                        @if (group.radioGroup) {
                          <div
                            sui-radio-group
                            orientation="vertical"
                            [ngModel]="timeShown"
                            [ngModelOptions]="{ standalone: true }"
                            (valueChange)="onViewRadioChange(group, $event)"
                          >
                            @for (item of group.items; track item) {
                              <sui-radio
                                class="dropdown-item"
                                indicatorPosition="trailing"
                                [value]="item.value"
                              >
                                @if (item.icon) {
                                  <fa-icon [icon]="item.icon"></fa-icon>
                                }
                                <span>{{ item.text }}</span>
                              </sui-radio>
                            }
                          </div>
                        } @else {
                          @for (item of group.items; track item) {
                            @if (item.isSeparator) {
                              <div class="dropdown-divider"></div>
                            } @else if (item.isTitle) {
                              <h6 class="dropdown-header">{{ item.text }}</h6>
                            } @else {
                              <sui-checkbox
                                class="dropdown-item"
                                indicatorPosition="trailing"
                                [checked]="!!item.isSelected"
                                (checkedChange)="onViewChange(item)"
                              >
                                @if (item.icon) {
                                  <fa-icon [icon]="item.icon"></fa-icon>
                                }
                                <span>{{ item.text }}</span>
                              </sui-checkbox>
                            }
                          }
                        }
                      }
                    </div>
                  </ng-template>
                </div>
                <!-- Relationship-status filter dropdown -->
                <div>
                  <div class="filter-dropdown">
                    <sui-button
                      variant="ghost"
                      [leadingIcon]="['fas', 'filter']"
                      [trailingIcon]="['fas', 'caret-down']"
                      [expanded]="filterDropdownRef.isOpen()"
                      [pressed]="relationFilterActive"
                      [suiMenuTrigger]="filterMenu"
                      #filterDropdownRef="suiMenu"
                    >
                      {{ "post-related.button.filter" | translate }}
                    </sui-button>
                  </div>

                  <ng-template #filterMenu>
                    <sui-menu>
                      <sui-menu-header>
                        {{
                          "post-related.filter.related-article-status"
                            | translate
                        }}
                      </sui-menu-header>
                      @for (item of relatedFilterItems; track item.value) {
                        <button
                          sui-menu-item
                          [selected]="item.value === relatedFilter"
                          (click)="
                            onFilterChange('related', item.value);
                            $event.stopPropagation()
                          "
                        >
                          <span>{{ item.text }}</span>
                        </button>
                      }
                      <sui-menu-separator></sui-menu-separator>
                      <sui-menu-header>
                        {{
                          "post-related.filter.parent-article-status"
                            | translate
                        }}
                      </sui-menu-header>
                      @for (item of parentFilterItems; track item.value) {
                        <button
                          sui-menu-item
                          [selected]="item.value === parentFilter"
                          (click)="
                            onFilterChange('parent', item.value);
                            $event.stopPropagation()
                          "
                        >
                          <span>{{ item.text }}</span>
                        </button>
                      }
                    </sui-menu>
                  </ng-template>
                </div>
                <!-- Sort dropdown -->
                <div>
                  <div class="sort-dropdown">
                    <sui-button
                      variant="ghost"
                      [leadingIcon]="['fas', 'arrow-down-z-a']"
                      [trailingIcon]="['fas', 'caret-down']"
                      [expanded]="sortDropdownRef.isOpen()"
                      [suiMenuTrigger]="sortMenu"
                      #sortDropdownRef="suiMenu"
                    >
                      {{ "post-related.button.sort" | translate }}
                    </sui-button>
                  </div>

                  <ng-template #sortMenu>
                    <sui-menu>
                      @for (item of sortDropdown; track item.value) {
                        @if (item.isSeparator) {
                          <sui-menu-separator></sui-menu-separator>
                        } @else {
                          <button
                            sui-menu-item
                            [selected]="
                              item.radioGroup === 'sort'
                                ? item.value === sortField
                                : item.value === sort
                            "
                            (click)="
                              onSortChange(item); $event.stopPropagation()
                            "
                          >
                            @if (item.icon) {
                              <fa-icon [icon]="item.icon"></fa-icon>
                            }
                            <span>{{ item.text }}</span>
                          </button>
                        }
                      }
                    </sui-menu>
                  </ng-template>
                </div>
                @if (posts?.length > 0) {
                  <sui-pagination
                    [currentPage]="currentPage"
                    [pageSize]="pageSize"
                    [collectionSize]="totalItems"
                    (pageChanged)="onPageChange($event)"
                    (doPageChange)="onPageChange($event)"
                  ></sui-pagination>
                }
              </div>
            }
          </app-post-list>
        </div>
      </div>
      <div class="related-posts-lists">
        <div class="post-view">
          <app-post-card
            [post]="post"
            [viewConfig]="postViewSettings"
            [selectable]="false"
            [disableTools]="true"
            [timeShown]="timeShown"
          ></app-post-card>
        </div>
        <div class="post-related">
          <div
            class="related-posts"
            cdkDropList
            [cdkDropListData]="postsRelated"
            (cdkDropListDropped)="onRelatedDrop($event)"
          >
            @for (post of postsRelated; track post.id) {
              <app-post-card
                cdkDrag
                [cdkDragData]="post"
                [post]="post"
                [viewMode]="'compact'"
                [sortable]="true"
                [disableTools]="true"
                [timeShown]="timeShown"
                [customTogglePostSelect]="togglePostSelect(post)"
                (togglePostParent)="togglePostParent(post)"
              ></app-post-card>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template suiDialogFooter>
    <sui-button size="md" variant="secondary" (click)="cancel()">
      {{ "btn.cancel" | translate }}
    </sui-button>
    <sui-button size="md" variant="primary" (click)="save()">
      {{ "btn.confirm" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
